module.exports = __webpack_public_path__ + "img/ctb.7976ac40.gif";